/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AddRolePermissions } from '@coin/shared/core/util-models-v2';
import { AddUserRoleParameter } from '@coin/shared/core/util-models-v2';
import { AddUserRoles } from '@coin/shared/core/util-models-v2';
import { BlockedUsersConfiguration } from '@coin/shared/core/util-models-v2';
import { Cluster } from '@coin/shared/core/util-models-v2';
import { ClusterGroup } from '@coin/shared/core/util-models-v2';
import { ClusterNode } from '@coin/shared/core/util-models-v2';
import { CreateClusterGroup } from '@coin/shared/core/util-models-v2';
import { CreateClusterMapping } from '@coin/shared/core/util-models-v2';
import { CreateClusterNodeOfCluster } from '@coin/shared/core/util-models-v2';
import { CreateClusterOfClusterGroup } from '@coin/shared/core/util-models-v2';
import { CreatePermission } from '@coin/shared/core/util-models-v2';
import { CreateRole } from '@coin/shared/core/util-models-v2';
import { EmployeesEmployeePreview } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { PageOfCluster } from '@coin/shared/core/util-models-v2';
import { PageOfClusterGroup } from '@coin/shared/core/util-models-v2';
import { PageOfClusterMapping } from '@coin/shared/core/util-models-v2';
import { PageOfClusterNode } from '@coin/shared/core/util-models-v2';
import { PageOfRole } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfUsersUsersUser } from '@coin/shared/core/util-models-v2';
import { Permission } from '@coin/shared/core/util-models-v2';
import { RemoveRolePermissions } from '@coin/shared/core/util-models-v2';
import { RemoveUserRoles } from '@coin/shared/core/util-models-v2';
import { Role } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfClusterRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateCluster } from '@coin/shared/core/util-models-v2';
import { UpdateClusterGroup } from '@coin/shared/core/util-models-v2';
import { UpdateClusterMapping } from '@coin/shared/core/util-models-v2';
import { UpdateClusterNode } from '@coin/shared/core/util-models-v2';
import { UpdatePermission } from '@coin/shared/core/util-models-v2';
import { UpdateRole } from '@coin/shared/core/util-models-v2';
import { UpdateUser } from '@coin/shared/core/util-models-v2';
import { UsersUsersCreateUser } from '@coin/shared/core/util-models-v2';
import { UsersUsersUser } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AddClusterClusterGroupsParams {
  /** The unique id of the cluster group to create the cluster in. */
  id: string;
  /** The data to create the new cluster with. */
  createClusterOfClusterGroup?: CreateClusterOfClusterGroup;
}

export interface AddClusterNodeClustersParams {
  /** The unique id of the cluster to create the cluster node for. */
  id: string;
  /** The data to create the new cluster node with. */
  createClusterNodeOfCluster?: CreateClusterNodeOfCluster;
}

export interface AddRolePermissionsParams {
  /** The unique id of the role to add permissions to. */
  roleId: string;
  /** The model data containing permissions to add. */
  addRolePermissions?: AddRolePermissions;
}

export interface AddRolesUserRolesParams {
  /** The unique id of the user to add roles to. */
  userId: string;
  /** The model data containing the roles to add. */
  addUserRoles?: AddUserRoles;
}

export interface AddUserParametersParams {
  /** The unique id of the user to add a parameter to. */
  userId: string;
  /** The model containing data to create the parameter that will be added to the user. */
  addUserRoleParameter?: AddUserRoleParameter;
}

export interface CreateBlockedUsersConfigurationParams {
  /** The data to create the new configuration with. */
  blockedUsersConfiguration?: BlockedUsersConfiguration;
}

export interface CreateClusterGroupsParams {
  /** The data to create the new cluster group with. */
  createClusterGroup?: CreateClusterGroup;
}

export interface CreateClusterMappingsParams {
  /** The data to create the new cluster mapping with. */
  createClusterMapping?: CreateClusterMapping;
}

export interface CreatePermissionsParams {
  /** The data to create the new permission with. */
  createPermission?: CreatePermission;
}

export interface CreateRolesParams {
  /** The data to create the new role with. */
  createRole?: CreateRole;
}

export interface DeleteBlockedUsersConfigurationParams {
  /** The unique id of the configuration to delete. */
  id: string;
}

export interface DeleteClusterClusterNodesParams {
  /** The unique id of the cluster node. */
  id: string;
}

export interface DeleteClusterClustersParams {
  /** The unique id of the cluster. */
  id: string;
}

export interface DeleteClusterMappingsParams {
  /** The unique id of the cluster mapping to delete. */
  id: string;
}

export interface DeletePermissionsParams {
  /** The unique id of the permission to delete. */
  id: string;
}

export interface DeleteRolesParams {
  /** The unique id of the role to delete. */
  id: string;
}

export interface FieldValuesClusterGroupsParams {
  /** The property that should be resolved as a field values. */
  targetProperty: 0;
  page?: number;
  size?: number;
}

export interface GetBlockedUsersConfigurationParams {
  /** The configurations unique id. */
  id: string;
}

export interface GetByQueryHrBusinessPartnersParams {
  /** The search to find employees either by gid or name. */
  search?: string;
}

export interface GetClusterGroupsParams {
  /** The cluster groups unique id. */
  id: string;
}

export interface GetClusterNodesParams {
  /** The cluster nodes unique id. */
  id: string;
}

export interface GetClustersParams {
  /** The clusters unique id. */
  id: string;
}

export interface GetPermissionsParams {
  /** The permissions unique id. */
  id: string;
}

export interface GetRolesParams {
  /** The roles unique id. */
  id: string;
}

export interface QueryClusterGroupsParams {
  /** The name of cluster groups to find. */
  name?: string;
  page?: number;
  size?: number;
}

export interface QueryClusterMappingsParams {
  pagePage?: number;
  pageSize?: number;
  sortOrderBy?: 'Asc' | 'Desc';
  sortProperty?: string;
  /** The cluster mapping type to find cluster mappings of. */
  type?: 0 | 1 | 2;
  /** The unique id of the cluster group to find cluster mappings for. */
  clusterGroupId?: string;
}

export interface QueryClusterNodesParams {
  /** The name of cluster nodes to find. */
  name?: string;
  /** The display name of cluster nodes to find. */
  displayName?: string;
  /** The type of cluster nodes to find. */
  type?: string;
  /** The unique id of the cluster to find cluster nodes from. */
  clusterId?: string;
  /** The unique ids of clusters to find cluster nodes from. */
  clusterIds?: Array<string>;
  /** Whether only cluster nodes should be returned that have a display name set. */
  isDisplayNameRequired?: boolean;
  /** Whether only cluster nodes should be returned that the current requesting user is a member of. */
  mustBeMemberOf?: boolean;
  page?: number;
  size?: number;
}

export interface QueryClustersParams {
  /** The name of clusters to find. */
  name?: string;
  /** The display name of clusters to find. */
  displayName?: string;
  /** The unique id of the cluster group to find clusters from. */
  clusterGroupId?: string;
  /** The unique ids of cluster groups to find clusters from. */
  clusterGroupIds?: Array<string>;
  /** Whether only clusters should be returned that contain nodes that the current requesting user is a member of. */
  mustBeMemberOf?: boolean;
  /** Whether only clusters should be returned that have a display name set. */
  isDisplayNameRequired?: boolean;
  page?: number;
  size?: number;
}

export interface QueryPermissionsParams {
  /** The unique id of the roles to return permissions of. */
  roleId?: string;
}

export interface QueryRolesParams {
  /** The id of roles to find. */
  id?: string;
  /** The name of roles to find. */
  name?: string;
  page?: number;
  size?: number;
}

export interface RecalculateClusterGroupsParams {
  /** The unique id of the cluster group to recalculate. */
  id: string;
}

export interface RecalculateFullClusterGroupsParams {
  /** The unique id of the cluster group to recalculate. */
  id: string;
}

export interface RemoveRolePermissionsParams {
  /** The unique id of the role to remove permissions from. */
  roleId: string;
  /** The model data containing permissions to remove. */
  removeRolePermissions?: RemoveRolePermissions;
}

export interface RemoveRolesUserRolesParams {
  /** The unique id of the user to remove roles from. */
  userId: string;
  /** The model data containing the roles to remove. */
  removeUserRoles?: RemoveUserRoles;
}

export interface RemoveUserParametersParams {
  /** The unique id of the user to remove a parameter from. */
  userId: string;
  /** The unique id of the parameter to remove from the user. */
  id: string;
}

export interface SimulateUserPopulationUsersParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** The ruleset to use to simulate a population. */
  ruleSet?: RuleSet;
}

export interface UpdateBlockedUsersConfigurationParams {
  /** The unique id of the configuration to update. */
  id: string;
  /** The data to update the configuration with. */
  blockedUsersConfiguration?: BlockedUsersConfiguration;
}

export interface UpdateClusterGroupsParams {
  /** The unique id of the cluster group to update. */
  id: string;
  /** The data to update the cluster group with. */
  updateClusterGroup?: UpdateClusterGroup;
}

export interface UpdateClusterMappingsParams {
  /** The data to update the cluster mapping with. */
  updateClusterMapping?: UpdateClusterMapping;
}

export interface UpdateClusterNodesParams {
  /** The unique id of the cluster node to update. */
  id: string;
  /** The data to update the cluster node with. */
  updateClusterNode?: UpdateClusterNode;
}

export interface UpdateClustersParams {
  /** The unique id of the cluster to update. */
  id: string;
  /** The data to update the cluster with. */
  updateCluster?: UpdateCluster;
}

export interface UpdatePermissionsParams {
  /** The unique id of the permission to update. */
  id: string;
  /** The data to update the permission with. */
  updatePermission?: UpdatePermission;
}

export interface UpdateRolesParams {
  /** The unique id of the role to update. */
  id: string;
  /** The data to update the role with. */
  updateRole?: UpdateRole;
}

export interface UpdateUsersParams {
  /** The unique id of the user to update. */
  id: string;
  /** The data to update the user with. */
  updateUser?: UpdateUser;
}

export interface UsersCreateUsersParams {
  /** The data to create the new user with. */
  usersUsersCreateUser?: UsersUsersCreateUser;
}

export interface UsersDeleteUsersParams {
  /** The unique id of the user to delete. */
  id: string;
}

export interface UsersGetUsersParams {
  /** The users unique id. */
  id: string;
}

export interface UsersQueryUsersParams {
  /** The gid of users to find. */
  gid?: string;
  /** The firstname of users to find. */
  firstName?: string;
  /** The lastname of users to find. */
  lastName?: string;
  /** The name of a role a user must be assigned to to be found. */
  roleName?: string;
  /** The type of UserStatus using the USerStatus enum */
  status?: Array<'Archived' | 'Active'>;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/clusters Creates a new cluster in specified cluster group with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addClusterClusterGroups(
    requestParameters?: AddClusterClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Cluster>;
  public addClusterClusterGroups(
    requestParameters?: AddClusterClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Cluster>>;
  public addClusterClusterGroups(
    requestParameters?: AddClusterClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Cluster>>;
  public addClusterClusterGroups(
    requestParameters?: AddClusterClusterGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addClusterClusterGroups', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/cluster-groups/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/clusters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createClusterOfClusterGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new cluster node for specified cluster with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addClusterNodeClusters(
    requestParameters?: AddClusterNodeClustersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterNode>;
  public addClusterNodeClusters(
    requestParameters?: AddClusterNodeClustersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterNode>>;
  public addClusterNodeClusters(
    requestParameters?: AddClusterNodeClustersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterNode>>;
  public addClusterNodeClusters(
    requestParameters?: AddClusterNodeClustersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addClusterNodeClusters', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/clusters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/cluster-nodes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createClusterNodeOfCluster,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Adds new permissions to an existing role.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addRolePermissions(
    requestParameters?: AddRolePermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Role>;
  public addRolePermissions(
    requestParameters?: AddRolePermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Role>>;
  public addRolePermissions(
    requestParameters?: AddRolePermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Role>>;
  public addRolePermissions(requestParameters?: AddRolePermissionsParams, ...args: RequestArgs): Observable<any> {
    const roleId = requestParameters?.roleId;
    this.checkRequired('addRolePermissions', { roleId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/roles/${this.configuration.encodeParam({ name: 'roleId', value: roleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.addRolePermissions,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Adds roles to an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addRolesUserRoles(
    requestParameters?: AddRolesUserRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public addRolesUserRoles(
    requestParameters?: AddRolesUserRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public addRolesUserRoles(
    requestParameters?: AddRolesUserRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public addRolesUserRoles(requestParameters?: AddRolesUserRolesParams, ...args: RequestArgs): Observable<any> {
    const userId = requestParameters?.userId;
    this.checkRequired('addRolesUserRoles', { userId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/roles`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.addUserRoles,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Adds a parameter to an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addUserParameters(
    requestParameters?: AddUserParametersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public addUserParameters(
    requestParameters?: AddUserParametersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public addUserParameters(
    requestParameters?: AddUserParametersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public addUserParameters(requestParameters?: AddUserParametersParams, ...args: RequestArgs): Observable<any> {
    const userId = requestParameters?.userId;
    this.checkRequired('addUserParameters', { userId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/parameters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.addUserRoleParameter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new configuration with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBlockedUsersConfiguration(
    requestParameters?: CreateBlockedUsersConfigurationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BlockedUsersConfiguration>;
  public createBlockedUsersConfiguration(
    requestParameters?: CreateBlockedUsersConfigurationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BlockedUsersConfiguration>>;
  public createBlockedUsersConfiguration(
    requestParameters?: CreateBlockedUsersConfigurationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BlockedUsersConfiguration>>;
  public createBlockedUsersConfiguration(
    requestParameters?: CreateBlockedUsersConfigurationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/users/blocked-users-configurations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.blockedUsersConfiguration,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups Creates a new cluster group with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClusterGroups(
    requestParameters?: CreateClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterGroup>;
  public createClusterGroups(
    requestParameters?: CreateClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterGroup>>;
  public createClusterGroups(
    requestParameters?: CreateClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterGroup>>;
  public createClusterGroups(requestParameters?: CreateClusterGroupsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/cluster-groups`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createClusterGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new cluster mapping with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClusterMappings(
    requestParameters?: CreateClusterMappingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public createClusterMappings(
    requestParameters?: CreateClusterMappingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public createClusterMappings(
    requestParameters?: CreateClusterMappingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public createClusterMappings(requestParameters?: CreateClusterMappingsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/users/admin/v1/cluster-mappings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createClusterMapping,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new permission with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPermissions(
    requestParameters?: CreatePermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Permission>;
  public createPermissions(
    requestParameters?: CreatePermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Permission>>;
  public createPermissions(
    requestParameters?: CreatePermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Permission>>;
  public createPermissions(requestParameters?: CreatePermissionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPermission,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new role with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRoles(
    requestParameters?: CreateRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Role>;
  public createRoles(
    requestParameters?: CreateRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Role>>;
  public createRoles(
    requestParameters?: CreateRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Role>>;
  public createRoles(requestParameters?: CreateRolesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/roles`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRole,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing configuration.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBlockedUsersConfiguration(
    requestParameters?: DeleteBlockedUsersConfigurationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteBlockedUsersConfiguration(
    requestParameters?: DeleteBlockedUsersConfigurationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteBlockedUsersConfiguration(
    requestParameters?: DeleteBlockedUsersConfigurationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteBlockedUsersConfiguration(
    requestParameters?: DeleteBlockedUsersConfigurationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteBlockedUsersConfiguration', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/users/blocked-users-configurations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Deletes a cluster node with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClusterClusterNodes(
    requestParameters?: DeleteClusterClusterNodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteClusterClusterNodes(
    requestParameters?: DeleteClusterClusterNodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteClusterClusterNodes(
    requestParameters?: DeleteClusterClusterNodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteClusterClusterNodes(
    requestParameters?: DeleteClusterClusterNodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteClusterClusterNodes', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/cluster-nodes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes a whole cluster with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClusterClusters(
    requestParameters?: DeleteClusterClustersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteClusterClusters(
    requestParameters?: DeleteClusterClustersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteClusterClusters(
    requestParameters?: DeleteClusterClustersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteClusterClusters(requestParameters?: DeleteClusterClustersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteClusterClusters', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/clusters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes an existing cluster mapping.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClusterMappings(
    requestParameters?: DeleteClusterMappingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteClusterMappings(
    requestParameters?: DeleteClusterMappingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteClusterMappings(
    requestParameters?: DeleteClusterMappingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteClusterMappings(requestParameters?: DeleteClusterMappingsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteClusterMappings', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/users/admin/v1/cluster-mappings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Deletes an existing permission.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePermissions(
    requestParameters?: DeletePermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deletePermissions(
    requestParameters?: DeletePermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deletePermissions(
    requestParameters?: DeletePermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deletePermissions(requestParameters?: DeletePermissionsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deletePermissions', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/permissions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Deletes an existing role.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRoles(
    requestParameters?: DeleteRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteRoles(
    requestParameters?: DeleteRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteRoles(
    requestParameters?: DeleteRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteRoles(requestParameters?: DeleteRolesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteRoles', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/roles/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/field-values Queries field values for existing cluster groups by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldValuesClusterGroups(
    requestParameters?: FieldValuesClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public fieldValuesClusterGroups(
    requestParameters?: FieldValuesClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public fieldValuesClusterGroups(
    requestParameters?: FieldValuesClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public fieldValuesClusterGroups(
    requestParameters?: FieldValuesClusterGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('fieldValuesClusterGroups', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/cluster-groups/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { TargetProperty: targetProperty, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Gets all configurations.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllBlockedUsersConfiguration(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BlockedUsersConfiguration>>;
  public getAllBlockedUsersConfiguration(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BlockedUsersConfiguration>>>;
  public getAllBlockedUsersConfiguration(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BlockedUsersConfiguration>>>;
  public getAllBlockedUsersConfiguration(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users/blocked-users-configurations`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a configuration by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBlockedUsersConfiguration(
    requestParameters?: GetBlockedUsersConfigurationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BlockedUsersConfiguration>;
  public getBlockedUsersConfiguration(
    requestParameters?: GetBlockedUsersConfigurationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BlockedUsersConfiguration>>;
  public getBlockedUsersConfiguration(
    requestParameters?: GetBlockedUsersConfigurationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BlockedUsersConfiguration>>;
  public getBlockedUsersConfiguration(
    requestParameters?: GetBlockedUsersConfigurationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getBlockedUsersConfiguration', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users/blocked-users-configurations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByQueryHrBusinessPartners(
    requestParameters?: GetByQueryHrBusinessPartnersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<EmployeesEmployeePreview>>;
  public getByQueryHrBusinessPartners(
    requestParameters?: GetByQueryHrBusinessPartnersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<EmployeesEmployeePreview>>>;
  public getByQueryHrBusinessPartners(
    requestParameters?: GetByQueryHrBusinessPartnersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<EmployeesEmployeePreview>>>;
  public getByQueryHrBusinessPartners(
    requestParameters?: GetByQueryHrBusinessPartnersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/hr-business-partners`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search }
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/ Gets an existing cluster group by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClusterGroups(
    requestParameters?: GetClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterGroup>;
  public getClusterGroups(
    requestParameters?: GetClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterGroup>>;
  public getClusterGroups(
    requestParameters?: GetClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterGroup>>;
  public getClusterGroups(requestParameters?: GetClusterGroupsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getClusterGroups', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/cluster-groups/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-nodes/ Gets an existing cluster node by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClusterNodes(
    requestParameters?: GetClusterNodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterNode>;
  public getClusterNodes(
    requestParameters?: GetClusterNodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterNode>>;
  public getClusterNodes(
    requestParameters?: GetClusterNodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterNode>>;
  public getClusterNodes(requestParameters?: GetClusterNodesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getClusterNodes', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/cluster-nodes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing cluster by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClusters(
    requestParameters?: GetClustersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Cluster>;
  public getClusters(
    requestParameters?: GetClustersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Cluster>>;
  public getClusters(
    requestParameters?: GetClustersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Cluster>>;
  public getClusters(requestParameters?: GetClustersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getClusters', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/clusters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesForSpecialRolesEnumRoles(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public getFieldValuesForSpecialRolesEnumRoles(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public getFieldValuesForSpecialRolesEnumRoles(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public getFieldValuesForSpecialRolesEnumRoles(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/roles/special-roles`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a permission by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPermissions(
    requestParameters?: GetPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Permission>;
  public getPermissions(
    requestParameters?: GetPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Permission>>;
  public getPermissions(
    requestParameters?: GetPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Permission>>;
  public getPermissions(requestParameters?: GetPermissionsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getPermissions', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/permissions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets all available coin cluster mapping types that can be used to create cluster mappings with.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPossibleMappingTypesClusterMappings(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<{ [key: string]: string }>;
  public getPossibleMappingTypesClusterMappings(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<{ [key: string]: string }>>;
  public getPossibleMappingTypesClusterMappings(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<{ [key: string]: string }>>;
  public getPossibleMappingTypesClusterMappings(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/users/admin/v1/cluster-mappings/types`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets all available coin resources that can be used to create permissions with.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getResourcesPermissions(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public getResourcesPermissions(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public getResourcesPermissions(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public getResourcesPermissions(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/permissions/resources`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a role by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRoles(
    requestParameters?: GetRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Role>;
  public getRoles(
    requestParameters?: GetRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Role>>;
  public getRoles(
    requestParameters?: GetRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Role>>;
  public getRoles(requestParameters?: GetRolesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getRoles', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/roles/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the users search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeUsers(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopeUsers(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopeUsers(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopeUsers(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserAccessViewsUsers(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public getUserAccessViewsUsers(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public getUserAccessViewsUsers(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public getUserAccessViewsUsers(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users/access-views`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups Queries existing cluster groups by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClusterGroups(
    requestParameters?: QueryClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClusterGroup>;
  public queryClusterGroups(
    requestParameters?: QueryClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClusterGroup>>;
  public queryClusterGroups(
    requestParameters?: QueryClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClusterGroup>>;
  public queryClusterGroups(requestParameters?: QueryClusterGroupsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/cluster-groups`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Name: requestParameters?.name, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Queries existing cluster mappings by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClusterMappings(
    requestParameters?: QueryClusterMappingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClusterMapping>;
  public queryClusterMappings(
    requestParameters?: QueryClusterMappingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClusterMapping>>;
  public queryClusterMappings(
    requestParameters?: QueryClusterMappingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClusterMapping>>;
  public queryClusterMappings(requestParameters?: QueryClusterMappingsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/users/admin/v1/cluster-mappings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Page.Page': requestParameters?.pagePage,
        'Page.Size': requestParameters?.pageSize,
        'Sort.OrderBy': requestParameters?.sortOrderBy,
        'Sort.Property': requestParameters?.sortProperty,
        Type: requestParameters?.type,
        ClusterGroupId: requestParameters?.clusterGroupId
      }
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-nodes Queries existing cluster nodes by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClusterNodes(
    requestParameters?: QueryClusterNodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClusterNode>;
  public queryClusterNodes(
    requestParameters?: QueryClusterNodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClusterNode>>;
  public queryClusterNodes(
    requestParameters?: QueryClusterNodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClusterNode>>;
  public queryClusterNodes(requestParameters?: QueryClusterNodesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/cluster-nodes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Name: requestParameters?.name,
        DisplayName: requestParameters?.displayName,
        Type: requestParameters?.type,
        ClusterId: requestParameters?.clusterId,
        ClusterIds: requestParameters?.clusterIds,
        IsDisplayNameRequired: requestParameters?.isDisplayNameRequired,
        MustBeMemberOf: requestParameters?.mustBeMemberOf,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries existing clusters by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClusters(
    requestParameters?: QueryClustersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCluster>;
  public queryClusters(
    requestParameters?: QueryClustersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCluster>>;
  public queryClusters(
    requestParameters?: QueryClustersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCluster>>;
  public queryClusters(requestParameters?: QueryClustersParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/clusters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Name: requestParameters?.name,
        DisplayName: requestParameters?.displayName,
        ClusterGroupId: requestParameters?.clusterGroupId,
        ClusterGroupIds: requestParameters?.clusterGroupIds,
        MustBeMemberOf: requestParameters?.mustBeMemberOf,
        IsDisplayNameRequired: requestParameters?.isDisplayNameRequired,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries existing permissions by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPermissions(
    requestParameters?: QueryPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<Permission>>;
  public queryPermissions(
    requestParameters?: QueryPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<Permission>>>;
  public queryPermissions(
    requestParameters?: QueryPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<Permission>>>;
  public queryPermissions(requestParameters?: QueryPermissionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { RoleId: requestParameters?.roleId }
    });
  }

  /**
   * Queries existing roles by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRoles(
    requestParameters?: QueryRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRole>;
  public queryRoles(
    requestParameters?: QueryRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRole>>;
  public queryRoles(
    requestParameters?: QueryRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRole>>;
  public queryRoles(requestParameters?: QueryRolesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/roles`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Name: requestParameters?.name,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/recalculate Recalculates all clusters of specified cluster group.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateClusterGroups(
    requestParameters?: RecalculateClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfClusterRecalculationMetadata>;
  public recalculateClusterGroups(
    requestParameters?: RecalculateClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfClusterRecalculationMetadata>>;
  public recalculateClusterGroups(
    requestParameters?: RecalculateClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfClusterRecalculationMetadata>>;
  public recalculateClusterGroups(
    requestParameters?: RecalculateClusterGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('recalculateClusterGroups', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/cluster-groups/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/recalculate-complete Deletes all existing node members then recalculates all clusters of specified cluster group.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateFullClusterGroups(
    requestParameters?: RecalculateFullClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfClusterRecalculationMetadata>;
  public recalculateFullClusterGroups(
    requestParameters?: RecalculateFullClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfClusterRecalculationMetadata>>;
  public recalculateFullClusterGroups(
    requestParameters?: RecalculateFullClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfClusterRecalculationMetadata>>;
  public recalculateFullClusterGroups(
    requestParameters?: RecalculateFullClusterGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('recalculateFullClusterGroups', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/cluster-groups/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/recalculate-complete`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Removes existing permissions of an existing role.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeRolePermissions(
    requestParameters?: RemoveRolePermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Role>;
  public removeRolePermissions(
    requestParameters?: RemoveRolePermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Role>>;
  public removeRolePermissions(
    requestParameters?: RemoveRolePermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Role>>;
  public removeRolePermissions(requestParameters?: RemoveRolePermissionsParams, ...args: RequestArgs): Observable<any> {
    const roleId = requestParameters?.roleId;
    this.checkRequired('removeRolePermissions', { roleId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/roles/${this.configuration.encodeParam({ name: 'roleId', value: roleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.removeRolePermissions,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Removes roles from an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeRolesUserRoles(
    requestParameters?: RemoveRolesUserRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public removeRolesUserRoles(
    requestParameters?: RemoveRolesUserRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public removeRolesUserRoles(
    requestParameters?: RemoveRolesUserRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public removeRolesUserRoles(requestParameters?: RemoveRolesUserRolesParams, ...args: RequestArgs): Observable<any> {
    const userId = requestParameters?.userId;
    this.checkRequired('removeRolesUserRoles', { userId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/roles`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.removeUserRoles,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Removes a parameter from an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeUserParameters(
    requestParameters?: RemoveUserParametersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public removeUserParameters(
    requestParameters?: RemoveUserParametersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public removeUserParameters(
    requestParameters?: RemoveUserParametersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public removeUserParameters(requestParameters?: RemoveUserParametersParams, ...args: RequestArgs): Observable<any> {
    const userId = requestParameters?.userId;
    const id = requestParameters?.id;
    this.checkRequired('removeUserParameters', { userId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/parameters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Simulates a population of users based on provided ruleset.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateUserPopulationUsers(
    requestParameters?: SimulateUserPopulationUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfUsersUsersUser>;
  public simulateUserPopulationUsers(
    requestParameters?: SimulateUserPopulationUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfUsersUsersUser>>;
  public simulateUserPopulationUsers(
    requestParameters?: SimulateUserPopulationUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfUsersUsersUser>>;
  public simulateUserPopulationUsers(
    requestParameters?: SimulateUserPopulationUsersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/users/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing configuration.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBlockedUsersConfiguration(
    requestParameters?: UpdateBlockedUsersConfigurationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BlockedUsersConfiguration>;
  public updateBlockedUsersConfiguration(
    requestParameters?: UpdateBlockedUsersConfigurationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BlockedUsersConfiguration>>;
  public updateBlockedUsersConfiguration(
    requestParameters?: UpdateBlockedUsersConfigurationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BlockedUsersConfiguration>>;
  public updateBlockedUsersConfiguration(
    requestParameters?: UpdateBlockedUsersConfigurationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateBlockedUsersConfiguration', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/users/blocked-users-configurations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.blockedUsersConfiguration,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-groups/ Updates an existing cluster group.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClusterGroups(
    requestParameters?: UpdateClusterGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterGroup>;
  public updateClusterGroups(
    requestParameters?: UpdateClusterGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterGroup>>;
  public updateClusterGroups(
    requestParameters?: UpdateClusterGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterGroup>>;
  public updateClusterGroups(requestParameters?: UpdateClusterGroupsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateClusterGroups', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/cluster-groups/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateClusterGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing cluster mapping.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClusterMappings(
    requestParameters?: UpdateClusterMappingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public updateClusterMappings(
    requestParameters?: UpdateClusterMappingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public updateClusterMappings(
    requestParameters?: UpdateClusterMappingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public updateClusterMappings(requestParameters?: UpdateClusterMappingsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/users/admin/v1/cluster-mappings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateClusterMapping,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Defined Route: admin/api/v2/master/cluster-nodes/ Updates an existing cluster node.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClusterNodes(
    requestParameters?: UpdateClusterNodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClusterNode>;
  public updateClusterNodes(
    requestParameters?: UpdateClusterNodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClusterNode>>;
  public updateClusterNodes(
    requestParameters?: UpdateClusterNodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClusterNode>>;
  public updateClusterNodes(requestParameters?: UpdateClusterNodesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateClusterNodes', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/cluster-nodes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateClusterNode,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing cluster.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClusters(
    requestParameters?: UpdateClustersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Cluster>;
  public updateClusters(
    requestParameters?: UpdateClustersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Cluster>>;
  public updateClusters(
    requestParameters?: UpdateClustersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Cluster>>;
  public updateClusters(requestParameters?: UpdateClustersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateClusters', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/clusters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCluster,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing permission.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePermissions(
    requestParameters?: UpdatePermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Permission>;
  public updatePermissions(
    requestParameters?: UpdatePermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Permission>>;
  public updatePermissions(
    requestParameters?: UpdatePermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Permission>>;
  public updatePermissions(requestParameters?: UpdatePermissionsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updatePermissions', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/permissions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePermission,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing role.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRoles(
    requestParameters?: UpdateRolesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Role>;
  public updateRoles(
    requestParameters?: UpdateRolesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Role>>;
  public updateRoles(
    requestParameters?: UpdateRolesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Role>>;
  public updateRoles(requestParameters?: UpdateRolesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateRoles', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/roles/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateRole,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateUsers(
    requestParameters?: UpdateUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public updateUsers(
    requestParameters?: UpdateUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public updateUsers(
    requestParameters?: UpdateUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public updateUsers(requestParameters?: UpdateUsersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateUsers', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateUser,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new user with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersCreateUsers(
    requestParameters?: UsersCreateUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public usersCreateUsers(
    requestParameters?: UsersCreateUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public usersCreateUsers(
    requestParameters?: UsersCreateUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public usersCreateUsers(requestParameters?: UsersCreateUsersParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.usersUsersCreateUser,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersDeleteUsers(
    requestParameters?: UsersDeleteUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public usersDeleteUsers(
    requestParameters?: UsersDeleteUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public usersDeleteUsers(
    requestParameters?: UsersDeleteUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public usersDeleteUsers(requestParameters?: UsersDeleteUsersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('usersDeleteUsers', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a user by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersGetUsers(
    requestParameters?: UsersGetUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UsersUsersUser>;
  public usersGetUsers(
    requestParameters?: UsersGetUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UsersUsersUser>>;
  public usersGetUsers(
    requestParameters?: UsersGetUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UsersUsersUser>>;
  public usersGetUsers(requestParameters?: UsersGetUsersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('usersGetUsers', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries existing users by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersQueryUsers(
    requestParameters?: UsersQueryUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfUsersUsersUser>;
  public usersQueryUsers(
    requestParameters?: UsersQueryUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfUsersUsersUser>>;
  public usersQueryUsers(
    requestParameters?: UsersQueryUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfUsersUsersUser>>;
  public usersQueryUsers(requestParameters?: UsersQueryUsersParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        RoleName: requestParameters?.roleName,
        Status: requestParameters?.status,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }
}
